import React, { useEffect, useRef } from "react";

import ReactDOM from "react-dom";
import "fullpage.js/vendors/scrolloverflow"; // Optional. When using scrollOverflow:true
import "../navigation/navigation.css";
import gsap from "gsap";
import { TimelineLite, CSSPlugin } from "gsap/all";
import ReactFullpage from "@fullpage/react-fullpage";
import {
  Link,
  DirectLink,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller
} from "react-scroll";
import "./home.css";

import "./homepage.css";
import Platinum from "../platinum/platinum";
import ImgGridComp from "../imgGridComp/imgGridComp";
import HomeText from "../homeText/homeText";
// import EmeraldCutH from "../home/home";
import bg from "../../images/bg.webp";
import FirstComp from "./firstComp";
import SecondComp from "./secondComp";
import ThirdComp from "./thirdComp";
import FourthComp from "./fourthComp";
import FifthComp from "./fifthComp";
import Header from "../header/header";
import Banner from "../banner/banner";
import Footer from "../footer/footer";
import Home from "../navigation/images/home.svg";
import Back from "../navigation/images/back.svg";
import Forward from "../navigation/images/forward.svg";
import HoveredHome from "../navigation/images/home-hover.svg";

import Img1 from "../../images/imgComp/imgComp1.webp";
import Img2 from "../../images/imgComp/imgComp2.webp";
import Img3 from "../../images/imgComp/imgComp3.webp";
import Img4 from "../../images/imgComp/imgComp4.webp";
import Img5 from "../../images/imgComp/imgComp5.webp";

// tilt
import Tilt from "react-parallax-tilt";
import EmeraldCut from "./images/emeraldc.svg";
import EmeraldModel from "./images/emerald.webp";
import PrincessCut from "./images/princessc.svg";
import PearCut from "./images/pearc.svg";
import MarquiseCut from "./images/marquisec.svg";
import OvalCut from "./images/ovalc.svg";
import PrincessModel from "./images/princess.webp";
import PearModel from "./images/pear.webp";
import MarquiseModel from "./images/marquise.webp";
import OvalModel from "./images/oval.webp";

class Homepage extends React.Component {
  constructor(props) {
    super(props);
    this.sectionRef = null;
    this.sectionTween = null;
  }
  // componentDidMount(){
  // 	// create logo tween
  // 	this.logoTween = new TimelineLite({ paused:true })
  // 		.to(this.logoContainer, 2, { x: 500 })
  // 		.to(this.logoContainer, 1, { rotation: 360, transformOrigin: "center" });
  // }
  componentDidMount() {
    this.sectionTween = new TimelineLite({ paused: true }).to(
      this.sectionRef,
      2,
      { x: 2000 }
    );
    // .to(this.sectionRef, 1, { rotation: 360, transformOrigin: "center" });
  }
  onLeave(origin, destination, direction) {
    console.log("Leaving section " + origin.index);
  }
  afterLoad(origin, destination, direction) {
    console.log("After load: " + destination.index);
  }

  render() {
    function unhover(element) {
      element.setAttribute("src", Home);
    }

    return (
      <>
        <ReactFullpage
          recordHistory={false}
          normalScrollElements={".demo"}
          normalScrollElementTouchThreshold={1}
          touchSensitivity={10}
          // autoScrolling={false}
          //bigSectionsDestination={false}
          setLockAnchors={true}
          scrollOverflow={true}
          controlArrows={false}
          onLeave={this.onLeave.bind(this)}
          afterLoad={this.afterLoad.bind(this)}
          render={({ state, fullpageApi }) => {
            return (
              <div id="fullpage-wrapper">
                <div className="section">
                  <div
                    className="mainContainer demo"
                    style={{ backgroundImage: `url(${bg})` }}
                  >
                    {/* <Header /> */}
                    {/* <Platinum /> */}
                    <div className="emerald-comp">
                      <div class="multiple-tilt">
                        <Tilt
                          className="parallax-effect-img princessm"
                          tiltMaxAngleX={0}
                          tiltMaxAngleY={40}
                          perspective={800}
                          transitionSpeed={1500}
                          scale={1.1}
                          gyroscope={true}
                          trackOnWindow={false}
                          style={{
                            backgroundImage: `url(${PrincessModel})`
                          }}
                        >
                          <span class="title-cut-home">PRINCESS</span>
                          <img
                            src={PrincessCut}
                            className="inner-element princessc"
                            alt="pic"
                            onClick={() => fullpageApi.moveTo(2, 0)}
                          />
                        </Tilt>
                        <Tilt
                          className="parallax-effect-img"
                          tiltMaxAngleX={0}
                          tiltMaxAngleY={40}
                          perspective={800}
                          transitionSpeed={1500}
                          scale={1.1}
                          gyroscope={true}
                          trackOnWindow={false}
                          style={{ backgroundImage: `url(${PearModel})` }}
                        >
                          {/* <div > */}
                          <span class="title-cut-home">PEAR</span>
                          <img
                            src={PearCut}
                            className="inner-element pearc"
                            alt="pic"
                            onClick={() => fullpageApi.moveTo(2, 1)}
                          />
                          {/* </div> */}
                        </Tilt>
                        <Tilt
                          className="parallax-effect-img marquisem"
                          tiltMaxAngleX={0}
                          tiltMaxAngleY={40}
                          perspective={800}
                          transitionSpeed={1500}
                          scale={1.1}
                          gyroscope={true}
                          trackOnWindow={false}
                          style={{
                            backgroundImage: `url(${MarquiseModel})`
                          }}
                        >
                          {/* <div  */}
                          {/* // o */}
                          <span class="title-cut-home">MARQUISE</span>
                          <img
                            src={MarquiseCut}
                            className="inner-element marquisec"
                            alt="pic"
                            onClick={() => fullpageApi.moveTo(2, 2)}
                          />
                          {/* </div> */}
                        </Tilt>
                        <Tilt
                          className="parallax-effect-img emeraldm"
                          tiltMaxAngleX={0}
                          tiltMaxAngleY={40}
                          perspective={800}
                          transitionSpeed={1500}
                          scale={1.1}
                          gyroscope={true}
                          trackOnWindow={false}
                          style={{
                            backgroundImage: `url(${EmeraldModel})`
                          }}
                        >
                          {/* <div  */}
                          {/* // > */}
                          <span class="title-cut-home">EMERALD</span>
                          <img
                            src={EmeraldCut}
                            className="inner-element emeraldc"
                            alt="pic"
                            onClick={() => fullpageApi.moveTo(2, 3)}
                          />
                          {/* </div> */}
                        </Tilt>
                        <Tilt
                          className="parallax-effect-img ovalm"
                          tiltMaxAngleX={0}
                          tiltMaxAngleY={40}
                          perspective={800}
                          transitionSpeed={1500}
                          scale={1.1}
                          gyroscope={true}
                          trackOnWindow={false}
                          style={{ backgroundImage: `url(${OvalModel})` }}
                        >
                          {/* <div  */}
                          {/* // > */}
                          <span class="title-cut-home">OVAL</span>
                          <img
                            src={OvalCut}
                            className="inner-element ovalc"
                            alt="pic"
                            onClick={() => fullpageApi.moveTo(2, 4)}
                          />
                          {/* </div> */}
                        </Tilt>
                      </div>
                    </div>

                    {/* <HomeText /> */}
                    <div className="imgGridComp-main">
                      <div className="imgGridComp-grid">
                        <div
                          className="imgGridComp-grid-elem flirt"
                          onClick={() => fullpageApi.moveTo(2, 0)}
                        >
                          <div className="img-grid-elem ">
                            <img src={Img1} />
                          </div>
                          <div className="text-grid-elem">
                            <p>Cochetă</p>
                          </div>
                        </div>
                        <div
                          className="imgGridComp-grid-elem"
                          onClick={() => fullpageApi.moveTo(2, 1)}
                        >
                          <div className="img-grid-elem">
                            <img src={Img2} />
                          </div>
                          <div className="text-grid-elem">
                            <p>TRENDSETTER</p>
                          </div>
                        </div>
                        <div
                          className="imgGridComp-grid-elem seductive"
                          onClick={() => fullpageApi.moveTo(2, 2)}
                        >
                          <div className="img-grid-elem">
                            <img src={Img3} />
                          </div>
                          <div className="text-grid-elem">
                            <p>Seducătoare</p>
                          </div>
                        </div>
                        <div
                          className="imgGridComp-grid-elem confident"
                          onClick={() => fullpageApi.moveTo(2, 3)}
                        >
                          <div className="img-grid-elem">
                            <img src={Img4} />
                          </div>
                          <div className="text-grid-elem">
                            <p>Încrezătoare</p>
                          </div>
                        </div>
                        <div
                          className="imgGridComp-grid-elem creative"
                          onClick={() => fullpageApi.moveTo(2, 4)}
                        >
                          <div className="img-grid-elem">
                            <img src={Img5} />
                          </div>
                          <div className="text-grid-elem">
                            <p>Creativă</p>
                          </div>
                        </div>
                      </div>
                      {/* <div className="img-grid-text">
                        Arată cine ești și fii gata să strălucești. <br />
                        <span>pentru tine.</span>
                        <br />
                        Răsfață-te cu bijuteriile care vorbesc despre tine.{" "}
                        <br />
                      </div> */}
                    </div>

                    {/* <Footer /> */}
                  </div>
                </div>

                <div className="section" ref={(div) => (this.sectionRef = div)}>
                  <div className="demo">
                    <div className="navigation-main demo">
                      <div className="navigation-grid">
                        <div className="nav-elem back-elem">
                          <div
                            className="nav-elem-container"
                            onClick={() => fullpageApi.moveSlideLeft()}
                          >
                            <img src={Back} alt="" />
                          </div>
                        </div>
                        <div className="nav-elem home-elem">
                          <div className="nav-elem-container">
                            <img
                              // ref={(el) => (hoverRef = el)}
                              src={Home}
                              alt=""
                              // onMouseOver={() => hover(hoverRef)}
                              // onMouseLeave={() => unhover(hoverRef)}
                              onClick={() => fullpageApi.moveTo(1, 0)}
                            />
                            {/* <p>ALL CUTS</p> */}
                          </div>
                        </div>
                        <div className="nav-elem forward-elem">
                          <div
                            className="nav-elem-container"
                            onClick={() => fullpageApi.moveSlideRight()}
                          >
                            <img src={Forward} alt="" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="slide ">
                      <FirstComp />
                    </div>
                    <div className="slide ">
                      <SecondComp />
                    </div>
                    <div className="slide ">
                      <ThirdComp />
                    </div>
                    <div className="slide ">
                      <FourthComp />
                    </div>
                    <div className="slide ">
                      <FifthComp />
                    </div>
                  </div>
                </div>
              </div>
            );
          }}
        />
      </>
    );
  }
}

export default Homepage;
